<template>
  <div class="drawer-container">
    <transition-group
      name="drawer"
      tag="div"
    >
      <component
        :is="drawer.component"
        v-for="(drawer, index) in drawers"
        :key="index + 0"
        :class="{ 'drawer--left': drawer.attributes && drawer.attributes.left }"
        v-bind="drawer.attributes"
      />
    </transition-group>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import $ from 'jquery'

export default {
  name: 'Drawer',
  computed: {
    drawers () {
      return cloneDeep(this.$store.getters['drawer/drawers'])
    },
    active () {
      return this.$store.getters['drawer/drawers'].length
    },
    isLeft () {
      return this.$store.getters['drawer/left']
    },
  },
  mounted () {
    document.addEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleClickOutside (e) {
      const $drawer = $('.drawer__stage')

      if ($drawer.length && !$drawer[0].contains(e.target) && this.active) {
        this.$store.dispatch('drawer/close')
      }
    },
  },
}
</script>
